const CUSTOM_VALUE = 'VALUE';

const constructUrlPreview = ({
  destinationUrl,
  locationTrackingIdName,
  retailerTrackingIdName,
  brandTrackingIdName,
  redirectUrlParameterName,
  customParameters,
  redirectUrl,
  productParameters,
  quantityParameterName,
  productEncoding = 'indexed',
}) => {
  if (!destinationUrl) {
    return '';
  }

  const productParametersQuery = constructProductParametersQuery(
    productParameters,
    quantityParameterName,
    productEncoding,
  );
  const customParametersQuery = constructCustomParametersQuery(customParameters);
  const trackingAndAnalyticsQuery = constructTrackingAndAnalyticsQuery(
    locationTrackingIdName,
    retailerTrackingIdName,
    brandTrackingIdName,
  );
  const redirectUrlQuery = constructRedirectUrlQuery(redirectUrlParameterName, redirectUrl);

  const combinedQuery = [
    productParametersQuery,
    customParametersQuery,
    trackingAndAnalyticsQuery,
    redirectUrlQuery,
  ]
    .filter(Boolean)
    .join('&');

  return `${destinationUrl}/product?${combinedQuery}`;
};

const constructRedirectUrlQuery = (redirectUrlParameterName, redirectUrl) => {
  if (redirectUrlParameterName && redirectUrl) {
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    return `${redirectUrlParameterName}=${encodedRedirectUrl}`;
  }
  return '';
};

const constructCustomParametersQuery = (customParameters) => {
  const query = [];

  customParameters
    .filter((param) => param.key && param.value)
    .forEach((param) => {
      query.push(`${param.key}=${param.value}`);
    });

  return query.join('&');
};

const constructTrackingAndAnalyticsQuery = (
  locationParameterName,
  publisherParameterName,
  brandTrackingParameterName,
) => {
  const query = [];

  if (locationParameterName) {
    query.push(`${locationParameterName}=${CUSTOM_VALUE}`);
  }

  if (publisherParameterName) {
    query.push(`${publisherParameterName}=${CUSTOM_VALUE}`);
  }

  if (brandTrackingParameterName) {
    query.push(`${brandTrackingParameterName}=${CUSTOM_VALUE}`);
  }

  return query.join('&');
};

const constructProductParametersQuery = (productParameters, quantity, productEncoding) => {
  switch (productEncoding) {
    case 'indexed':
      return constructProductQueryIndexed(productParameters, quantity);
    case 'comma':
      return constructProductQueryComma(productParameters, quantity);
    case 'json':
      return constructProductQueryJson(productParameters, quantity);
    default:
      return '';
  }
};

const constructProductQueryIndexed = (productParameters, quantityParameterName) => {
  const constructSingleProductQuery = (index) => {
    const singleProductQuery = [];

    productParameters
      .filter((param) => param.parameterName && param.productField)
      .forEach((param) => {
        singleProductQuery.push(`${param.parameterName}_${index}=${CUSTOM_VALUE}`);
      });

    if (singleProductQuery.length && quantityParameterName)
      singleProductQuery.push(`${quantityParameterName}_${index}=${CUSTOM_VALUE}`);

    return singleProductQuery.join('&');
  };

  return [constructSingleProductQuery(1), constructSingleProductQuery(2)].filter(Boolean).join('&');
};

const constructProductQueryComma = (productParameters, quantityParameterName) => {
  const query = [];

  productParameters
    .filter((param) => param.parameterName && param.productField)
    .forEach((param) => {
      query.push(`${param.parameterName}=${CUSTOM_VALUE},${CUSTOM_VALUE}`);
    });

  if (query.length && quantityParameterName) {
    query.push(`${quantityParameterName}=${CUSTOM_VALUE},${CUSTOM_VALUE}`);
  }

  return query.join('&');
};

const constructProductQueryJson = (productParameters, quantityParameterName) => {
  const constructSingleProductQuery = () => {
    const singleProductQuery = [];

    productParameters
      .filter((param) => param.parameterName && param.productField)
      .forEach((param) => {
        singleProductQuery.push(`"${param.parameterName}":"${CUSTOM_VALUE}"`);
      });

    if (singleProductQuery.length && quantityParameterName) {
      singleProductQuery.push(`"${quantityParameterName}":"${CUSTOM_VALUE}"`);
    }

    return singleProductQuery.length ? `{${singleProductQuery.join(',')}}` : '';
  };

  const query = [constructSingleProductQuery(), constructSingleProductQuery()]
    .filter(Boolean)
    .join(',');

  return query ? `products=[${query}]` : '';
};

export default constructUrlPreview;
